import * as Zod from 'zod';

export const sourceTypesScheme = Zod.object({
  id: Zod.string(),
  label: Zod.string(),
});
